import { render } from "./TextDescription.vue?vue&type=template&id=6f38fa38"
import script from "./TextDescription.vue?vue&type=script&lang=js"
export * from "./TextDescription.vue?vue&type=script&lang=js"
script.render = render

export default script